// ===============================================================
// ---------------------------------------------------------------
// Dependencies
import { useEffect, useContext, Fragment, Suspense, lazy } from "react"

// Context
import AppContext from "../../Context/App/appContext"
import AppNavbar from "../Modules/AppNavbar"

// Modules
import Spinner from "../Modules/Spinner"
import Theme from "../Modules/Theme"
import StuckSixty60 from "../Modules/StuckSixty60"
import HowToPay60SixtyInfo from "../Modules/HowToPay60SixtyInfo"
import HowToPay60SixtyTips from "../Modules/HowToPay60SixtyTips"
// Lazy Modules
const HowToPay60SixtyShowcase = lazy(() => import("../Modules/HowToPay60SixtyShowcase"))

const Footer = lazy(() => import("../Modules/Footer"))

// ===============================================================
const HowToPay60Sixty = () => {
	// ---------------------------------------------------------------
	// Context
	const appContext = useContext(AppContext)
	const { business, getBusiness } = appContext

	// ---------------------------------------------------------------
	// Scroll to top on load and fetch content
	useEffect(() => {
		window.scrollTo(0, 0)
		getBusiness()
		// eslint-disable-next-line
	}, [])

	return (
		<Fragment>
			<Suspense fallback={<Spinner />}>
				{business ? (
					<Theme id="for-business" className="for-business">
						<AppNavbar />
						<HowToPay60SixtyShowcase />
						<HowToPay60SixtyInfo />
						<HowToPay60SixtyTips />
						<StuckSixty60 />
						<Footer />
					</Theme>
				) : (
					<Spinner />
				)}
			</Suspense>
		</Fragment>
	)
}

export default HowToPay60Sixty
